module.exports = __webpack_public_path__ + "media/images/slide02-ae683f018d8c3752bbe825580f01357f.jpg";